var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 35,
    width: 35,
    height: 34.8062,
    rx: 7,
    transform: "rotate(-90 0 35)",
    fill: "#49C858"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_6852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52949 17.3504C5.52891 19.4509 6.07775 21.5018 7.12135 23.3096L5.42969 29.4861L11.7506 27.8288C13.4989 28.7805 15.4577 29.2792 17.4483 29.2794H17.4535C24.0247 29.2794 29.3739 23.9322 29.3767 17.3598C29.3779 14.175 28.1388 11.1802 25.8874 8.92713C23.6365 6.67423 20.6428 5.43285 17.453 5.4314C10.881 5.4314 5.5323 10.7783 5.52959 17.3504",
    fill: "url(#paint0_linear_800_6852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10368 17.3465C5.103 19.5226 5.67151 21.6469 6.75233 23.5194L5 29.9173L11.5476 28.2006C13.3516 29.1842 15.3828 29.7028 17.4497 29.7036H17.455C24.262 29.7036 29.8033 24.1641 29.8062 17.3564C29.8074 14.0572 28.5236 10.9547 26.1919 8.62093C23.8598 6.2874 20.759 5.00136 17.455 5C10.6469 5 5.10649 10.5388 5.10378 17.3465H5.10368ZM9.00291 23.1969L8.75843 22.8088C7.73072 21.1747 7.18828 19.2863 7.18905 17.3473C7.19128 11.6889 11.7963 7.08527 17.4589 7.08527C20.2012 7.08643 22.7783 8.15543 24.7167 10.095C26.6549 12.0347 27.7215 14.6132 27.7208 17.3556C27.7183 23.0141 23.1132 27.6182 17.455 27.6182H17.451C15.6086 27.6172 13.8017 27.1225 12.226 26.1875L11.851 25.9651L7.9655 26.9838L9.00291 23.1968V23.1969Z",
    fill: "url(#paint1_linear_800_6852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3686 12.1849C14.1374 11.671 13.8941 11.6607 13.6743 11.6517C13.4942 11.6439 13.2884 11.6445 13.0828 11.6445C12.877 11.6445 12.5426 11.7219 12.2599 12.0305C11.977 12.3394 11.1797 13.086 11.1797 14.6043C11.1797 16.1227 12.2856 17.59 12.4398 17.7961C12.5941 18.0018 14.5747 21.2173 17.7116 22.4544C20.3185 23.4824 20.8491 23.2779 21.4149 23.2264C21.9808 23.175 23.2408 22.48 23.4979 21.7594C23.7552 21.0389 23.7552 20.4212 23.678 20.2922C23.6009 20.1636 23.3951 20.0863 23.0865 19.9321C22.7777 19.7777 21.2605 19.0311 20.9777 18.9281C20.6947 18.8252 20.489 18.7738 20.2832 19.0829C20.0774 19.3914 19.4864 20.0863 19.3062 20.2922C19.1263 20.4985 18.9462 20.5241 18.6376 20.3698C18.3288 20.2149 17.3349 19.8894 16.1558 18.8382C15.2383 18.0202 14.6189 17.01 14.4389 16.701C14.2589 16.3924 14.4196 16.2252 14.5744 16.0714C14.713 15.9331 14.8831 15.7111 15.0375 15.5309C15.1914 15.3507 15.2428 15.2221 15.3457 15.0163C15.4487 14.8103 15.3971 14.63 15.3201 14.4757C15.2428 14.3213 14.6431 12.7952 14.3686 12.185",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_800_6852",
    x1: 17.4032,
    y1: 29.4861,
    x2: 17.4032,
    y2: 5.4314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_800_6852",
    x1: 17.4031,
    y1: 29.9173,
    x2: 17.4031,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_6852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8062,
    height: 25,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.da67cd200414a06fe4b841c6e5f3180a.svg";
export { ForwardRef as ReactComponent };